<template>
  <section class="step-footer">
    <slot/>
  </section>
</template>

<script>
export default {
  // Name
  name: 'step-footer'
}
</script>

<style scoped lang="scss">
.step-footer {
  text-align: center;
  padding: 20px 15px;
  margin: auto;

  @include breakpoint('tablet-portrait-up') {
    width: 560px;
    padding: 20px 0;
  }

  @include breakpoint('tablet-landscape-up') {
    padding: 45px 0;
  }

  @include breakpoint('desktop-up') {
    padding: 0 0 45px 0;
  }
}
</style>
